import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TimeOccurrenceService } from "services/corporate/timeOccurrence.service";

@Component({
  selector: "app-reprove-absence-dialog",
  templateUrl: "./reprove-absence-dialog.component.html",
  styleUrls: ["./reprove-absence-dialog.component.scss"],
})
export class ReproveAbsenceDialogComponent implements OnInit {
  @Input() title: string = "Reprovar tratamento";
  reproveReason: string = "";

  constructor(
    public activeModal: NgbActiveModal,
    public timeOccurrenceService: TimeOccurrenceService
  ) { }

  ngOnInit(): void { }

  onConfirm(): void {
    this.activeModal.close(this.reproveReason);
  }

  onDismiss(): void {
    this.activeModal.close(false);
  }
}
